var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OmtRow',{attrs:{"flex-direction":"column","p":_vm.p,"mt":_vm.mt,"mb":_vm.mb,"bg":"var(--colors-light-primary-light-gray)","borderRadius":"8px"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }